
import { IRoleAccess } from '../types';



export const policy: IRoleAccess = {
  sharedResource: {
    create: false,
    delete: false,
    update: false,
    view: false
  },
  superIntendent: {
    create: true,
    delete: true,
    update: true,
    view: true
  },
  admin: {
    create: true,
    delete: true,
    update: true,
    view: true
  },
  client: {
    create: false,
    delete: false,
    update: false,
    view: true
  },
  contractor: {
    create: false,
    delete: false,
    update: false,
    view: true
  },
  designer: {
    create: false,
    delete: false,
    update: false,
    view: true
  },
  staff: {
    create: true,
    delete: true,
    update: true,
    view: true
  }
};
